<template>
	<v-card v-if="card" class="background elevation-0 darken-1">
		<v-card-title class="pa-2 title">
			<v-btn
				flat icon
				v-if="is_child"
				@click="$emit('close')"
				class="ma-0 mr-3">
				<v-icon>close</v-icon>
			</v-btn>
			<span>{{ card.label }} [{{ card.id }}]</span>
		</v-card-title>
		<v-card-text class="background darken-1 pa-0">
			<div color="background darken-1" icons-and-text>
				<div>
					<v-card flat class="background darken-1">
						<v-card-text>
							<v-layout row wrap justify-center>
								<v-flex xs6 class="pr-0">
									<table>
										<tbody>
											<tr>
												<th style="white-space: nowrap;" class="title primary--text pb-3 pl-1 pr-1">
													{{ card.subtype_text }}
												</th>
												<td></td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">ID</th>
												<td>{{ card.id }}</td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">Creation Date</th>
												<td>{{ card.creation_date | formatDate }}</td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">Last Update</th>
												<td>{{ card.last_update | formatDate }}</td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">Title Language</th>
												<td>{{ card.title_language }}</td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">Episode Num</th>
												<td>{{ card.episode_num }}</td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">Duration</th>
												<td>{{ card.data.duration }}</td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">Production Year</th>
												<td>{{ card.data.production_year }}</td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">Type</th>
												<td>{{ card.data.type }}</td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">Genre</th>
												<td>{{ card.data.genre }}</td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">Target</th>
												<td>{{ card.data.target }}</td>
											</tr>
											<tr>
												<th style="white-space: nowrap;" class="pl-1 pr-1">Synopsis</th>
												<td>{{ card.data.synopsis }}</td>
											</tr>
											<tr v-if="card.data.casting !== undefined && card.data.casting.length > 0">
												<th style="white-space: nowrap;" class="pl-1 pr-1">Casting</th>
												<td class="pa-0">
													<table>
														<tr
															v-for="(cast, i) in card.data.casting"
															:key="'cast' + i">
															<th style="white-space: nowrap;" class="pr-1">{{ cast.role }}</th>
															<td>{{ cast.name }}</td>
														</tr>
													</table>
												</td>
											</tr>
										</tbody>
									</table>
								</v-flex>
								<v-flex xs6 class="pl-0">
									<table>
										<tbody>
											<tr>
												<td colspan="2" class="title primary--text pb-3">
													Localized Info
												</td>
											</tr>
											<tr
												v-for="(locale, i) in card.data.localized_info"
												:key="'locale' + i">
												<th>
													<v-chip
														label
														color="primary color--text"
														class="font-weight-bold">
														{{ locale.language }}
													</v-chip>
												</th>
												<td class="pa-0">
													<table>
														<tr>
															<th>Language</th>
															<td>{{ locale.language }}</td>
														</tr>
														<tr>
															<th>Title</th>
															<td>{{ locale.title }}</td>
														</tr>
														<tr>
															<th style="white-space: nowrap;" class="pr-1">Origin Country</th>
															<td>{{ locale.origin_country }}</td>
														</tr>
														<tr>
															<th>Target</th>
															<td>{{ locale.target }}</td>
														</tr>
														<tr>
															<th>Synopsis</th>
															<td>{{ locale.synopsis }}</td>
														</tr>
														<tr>
															<th>Genre</th>
															<td>{{ locale.genre }}</td>
														</tr>
														<tr>
															<th>Type</th>
															<td>{{ locale.type }}</td>
														</tr>
													</table>
												</td>
											</tr>
										</tbody>
									</table>
								</v-flex>
							</v-layout>
							<v-divider class="primary"></v-divider>
							<div class="pa-2">
								<tree-view
									:data="card"
									:options="{maxDepth: 0, rootObjectKey: 'Données Brutes'}" />
							</div>
						</v-card-text>
					</v-card>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	props: [
		'card',
		'is_child' // This vue is called inside a parent vue
	]
}
</script>



// WEBPACK FOOTER //
// src/components/babel_card_view.vue